import { Navigate } from 'react-router-dom';
import { useRefreshUserOnRouteChange } from '../hooks/useRefreshUserOnRouteChange';
import FlowLayoutShell from './FlowLayoutShell';

const KycLayout = () => {
    const user = useRefreshUserOnRouteChange();

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    const status = user?.orgStatusId || user?.businessProfile?.orgStatusId || user?.userStatusId;
    const userTypeId = user?.userTypeId || user?.businessProfile?.userTypeId;
    const isEntityOrHufOrNbfc = userTypeId === "UTY1000002" || userTypeId === "UTY1000006" || userTypeId === "UTY1000008";

    const s1Verified = (user?.step1Status || user?.businessProfile?.step1Status) === 'VERIFIED';
    const s2Verified = (user?.step2Status || user?.businessProfile?.step2Status) === 'VERIFIED';
    const s3Verified = (user?.step3Status || user?.businessProfile?.step3Status) === 'VERIFIED';

    const s1Rejected = (user?.step1Status || user?.businessProfile?.step1Status) === 'REJECTED';
    const s2Rejected = (user?.step2Status || user?.businessProfile?.step2Status) === 'REJECTED';
    const s3Rejected = (user?.step3Status || user?.businessProfile?.step3Status) === 'REJECTED';
    const hasAnyRejection = status === "USM1000006" || s1Rejected || s2Rejected || s3Rejected;

    const allStepsVerified = isEntityOrHufOrNbfc ? (s1Verified && s2Verified && s3Verified) : (s1Verified && s2Verified);
    const isFullyVerified = !hasAnyRejection && (status === "USM1000009" || allStepsVerified);

    if (isFullyVerified && sessionStorage.getItem("kyc_modal_proceeded") === "true") {
        const isEntityOrNbfc = userTypeId === "UTY1000006" || userTypeId === "UTY1000008";
        return <Navigate to={isEntityOrNbfc ? "/sla" : "/nominee"} replace />;
    }

    // Keep user on /kyc for PENDING, KYC_PENDING, KYC_REVIEW, or KYC_VERIFIED
    const allowedKycStatuses = ["USM1000007", "USM1000008", "USM1000010", "USM1000009"];
    if (!allowedKycStatuses.includes(status)) {
        return <Navigate to="/onboarding" replace />;
    }

    return <FlowLayoutShell contentClassName="kyc-content" />;
};

export default KycLayout;
